import { FloatingPlacement } from './Floating.types';

export const verticalPlacements = [
  FloatingPlacement.Top,
  FloatingPlacement.TopStart,
  FloatingPlacement.TopEnd,
  FloatingPlacement.Bottom,
  FloatingPlacement.BottomEnd,
  FloatingPlacement.BottomStart,
];

export const horizontalPlacements = [
  FloatingPlacement.Left,
  FloatingPlacement.LeftStart,
  FloatingPlacement.LeftEnd,
  FloatingPlacement.Right,
  FloatingPlacement.RightStart,
  FloatingPlacement.RightEnd,
];

export const allowedHorizontalReplacements = {
  [FloatingPlacement.Left]: [FloatingPlacement.Right, FloatingPlacement.Top, FloatingPlacement.Bottom],
  [FloatingPlacement.Right]: [FloatingPlacement.Left, FloatingPlacement.Top, FloatingPlacement.Bottom],
  [FloatingPlacement.LeftStart]: [FloatingPlacement.RightStart, FloatingPlacement.Top, FloatingPlacement.Bottom],
  [FloatingPlacement.RightStart]: [FloatingPlacement.LeftStart, FloatingPlacement.Top, FloatingPlacement.Bottom],
  [FloatingPlacement.LeftEnd]: [FloatingPlacement.RightEnd, FloatingPlacement.Top, FloatingPlacement.Bottom],
  [FloatingPlacement.RightEnd]: [FloatingPlacement.LeftEnd, FloatingPlacement.Top, FloatingPlacement.Bottom],
};
